import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { VerificationRoutingModule } from './verification-routing.module';
import { VerifyPhoneComponent } from './verify-phone/verify-phone.component';

@NgModule({
  imports: [CommonModule, SharedModule, VerificationRoutingModule],
  declarations: [VerifyPhoneComponent],
})
export class VerificationModule {}
